import {useEffect, useState} from 'react';

/** Primary input is mouse/trackpad — keyboard shortcut hints are meaningful. */
const KEYBOARD_INPUT_MEDIA_QUERY = '(hover: hover) and (pointer: fine)';

/**
 * True when the device likely has a physical keyboard and precise pointer
 * (desktop/laptop, or tablet with trackpad/keyboard). False for touch-primary
 * phones and tablets without an attached keyboard.
 */
export const useHasKeyboardInput = (): boolean => {
    const [hasKeyboardInput, setHasKeyboardInput] = useState(() => {
        if (typeof window === 'undefined') {
            return true;
        }
        return window.matchMedia(KEYBOARD_INPUT_MEDIA_QUERY).matches;
    });

    useEffect(() => {
        const mediaQuery = window.matchMedia(KEYBOARD_INPUT_MEDIA_QUERY);
        const handleChange = () => setHasKeyboardInput(mediaQuery.matches);
        handleChange();
        mediaQuery.addEventListener('change', handleChange);
        return () => mediaQuery.removeEventListener('change', handleChange);
    }, []);

    return hasKeyboardInput;
};
